module.exports = require('./createEmbedCode')
